import axios from 'axios';
import mutationHelpers from '../../utils/mutation-helpers';

const state = {
  status: null,
  stats: [],
  errors: []
};

// getters
const getters = {};

// actions
const actions = {
  ADD_STATS: async ({ commit }) => {
    try {
      // request site stats
      const { data } = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/api/stats-site`
      );
      commit('SET_SITE_STATS', data);

      return data.stats;
    } catch (error) {
      commit('SET_ERROR', error);
      throw new Error(error);
    }
  }
};

// mutations
const mutations = {
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR,
  SET_SITE_STATS: (state, data) => {
    state.stats = data.stats;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
